/*
 * Customized to add cookies from store config.
 */
import { useSettings } from '@/data/Settings';
import { getMarketingCookieContentTarget } from '@/data/utils/getMarketingCookieContentTarget';
import { useMemo } from 'react';
import { useCookies } from 'react-cookie';

export const useMarketingCookieContentTarget = () => {
	const [cookies] = useCookies();
	const { settings } = useSettings();
	const ALLOWED_COOKIES_NAMES: string = settings?.userData?.ALLOWED_COOKIES_NAMES ?? '';
	const ALLOWED_COOKIE_NAME_PREFIXES: string =
		settings?.userData?.ALLOWED_COOKIE_NAME_PREFIXES ?? '';
	const targets = useMemo(
		() =>
			getMarketingCookieContentTarget({
				cookies,
				allowedCookies: ALLOWED_COOKIES_NAMES.split(','),
				allowedPrefixed: ALLOWED_COOKIE_NAME_PREFIXES.split(','),
			}),
		[cookies, ALLOWED_COOKIES_NAMES, ALLOWED_COOKIE_NAME_PREFIXES]
	);
	return targets;
};
